// extracted by mini-css-extract-plugin
module.exports = {"media":"Media-module--media--3bH6o"};